import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { useAxios } from "../useAxios";
import { LevelCCandidateDetail } from "../../types/levelc-reports";

export interface UseGetLevelCCandidateDetailOptions {
  examInstanceId: string | null;
  enabled?: boolean;
}

export function useGetLevelCCandidateDetail({
  examInstanceId,
  enabled = true,
}: UseGetLevelCCandidateDetailOptions) {
  const { t } = useTranslation();
  const axios = useAxios();

  return useQuery<LevelCCandidateDetail | null>({
    queryKey: ["levelDCandidateDetail", examInstanceId],
    queryFn: async () => {
      if (!examInstanceId) {
        return null;
      }

      try {
        const response = await axios.get<LevelCCandidateDetail>(
          `api/levelcreports/candidates/${examInstanceId}`
        );
        return response.data;
      } catch (error: unknown) {
        if ((error as { response?: { status: number } })?.response?.status === 404) {
          return null;
        }
        message.error(t("levelCReports.errors.getCandidateDetail"));
        throw error;
      }
    },
    enabled: enabled && !!examInstanceId,
    staleTime: 30 * 1000, // 30 seconds
    retry: 1,
  });
}

